<template lang="html">
  <div class="model-points-soon">
    <div class="box">
      <header></header>
      <div class="title">即将到账的积分</div>
      <div class="subtitle">即将到账积分为购买商品或参加活动赠送的积分，在一定时间后积分将会到账并归入您的可用积分。</div>

      <footer><div @click="onSubmit">我知道了</div></footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModelPointsSoon',
  props: {
    onSubmit: {
      type: Function,
      default: () => null
    }
  }
}
</script>

<style lang="stylus" scoped>
.model-points-soon
  position fixed
  top 0
  left 0
  z-index 1
  display flex
  align-items center
  width 100%
  height 100%
  background-color rgba(0, 0, 0, .5)

  & > .box
    width (334 * 2 / 100)rem
    margin 0 auto
    height auto
    padding-top .4rem
    background-color #fff
    border-radius .16rem

    & > footer
      width 100%
      padding-bottom .6rem

      & > div
        height 1rem
        line-height @height
        margin 0 .4rem
        color #50462d
        font-size .32rem
        font-weight bold
        text-align center
        background-image linear-gradient(to right, #e9cc8a, #dfb27c)
        border-radius 1rem

    & > header
      width (185 * 2 / 100)rem
      height (104 * 2 / 100)rem
      margin 0 auto
      background-image url('./images/bg-header.png')
      background-size cover
      background-position center

    & > .title
      font-size .4rem
      font-weight bold
      color #000
      text-align center
      margin-top .58rem

    & > .subtitle
      padding 0 .4rem
      margin-top .1rem
      margin-bottom .2rem
      color #9b9b9b
      font-size .28rem


</style>
